export const removeSpaceBeforeSymbol = (phase: string) => {
  const regex = / +([&\\[\]:,$@/\-_!=<>()\u20ac%+?'"]+)/g;
  return phase.replace(regex, '$1');
};
